import styles from './StaffList.css'
import {connect} from 'react-redux'
import {OverlayTrigger, Popover} from 'react-bootstrap'
import {
  resendInvitation,
  askDeleteEmployee
} from 'actions/employees/list'

class StaffList extends React.Component {
  render () {
    let {employees, profile} = this.props.data.employee.list
    return (employees.length > 0 &&
    <div className={`${styles.wrapper} table-responsive`}>
      <table className={`table table-collapse ${styles.table}`}>
        <thead className={styles.thead}>
          <tr className={styles.tr}>
            <th className={styles.name}>Name</th>
            <th className={styles.email}>Email</th>
            <th className={styles.title}>Title</th>
            {profile && profile.is_owner && <th className={styles.permissions}>Permissions</th>}
            <th className={styles.access}>Access</th>
            <th className={styles.resend}>&nbsp;</th>
            <th className={styles.delete}>&nbsp;</th>
          </tr>
        </thead>
        <tbody className={styles.tbody}>
          {profile.is_manager && employees.map((user) => {
            const popover = (<Popover title='Assigned Outlet'>
              <ul>
                {user.outlets.map((outlet) => (<li className={'word-break-all ' + styles['popover-outlet-name']}>&bull; {outlet.name}</li>))}
              </ul>
            </Popover>)

            return (<tr className={styles.tr}>
              <td className={styles.name}>{user.first_name} {user.last_name}</td>
              <td className={styles.email}>{user.email}</td>
              <td className={styles.title}>{user.title}</td>
              <td className={styles.access}>
                {user.outlets.length > 1 && <OverlayTrigger placement='top' overlay={popover}>
                  <button className='btn btn-info'>{user.outlets.length} Outlets</button>
                  </OverlayTrigger>}
                {user.outlets.length === 1 && user.outlets[0].name}
              </td>
              <td className={styles.resend}>
                {!user.is_confirmed && <button onClick={() => this._resendInvitation(user.email)} className='btn btn-primary'>
                  Resend Invitation
                </button>}
              </td>
              <td className={styles.delete}>
                <button onClick={() => this._askConfirmDelete(user)} className='btn btn-danger'>
                  <i className='glyphicon glyphicon-trash' />
                </button>
              </td>
            </tr>)
          })}
          {profile.is_owner && employees.map((emp) => {
            let {user} = emp
            let employeeOutlet = user.employee_outlets.sort(function (a, b) {
              return a.outlet.name < b.outlet.name ? -1 : a.outlet.name > b.outlet.name ? 1 : 0
            })
            const popover = (<Popover title='Assigned Outlet'>
              <ul>
                {employeeOutlet.map((eo) => (<li className={'word-break-all ' + styles['popover-outlet-name']}>&bull; {eo.outlet.name}</li>))}
              </ul>
            </Popover>)

            return (<tr className={styles.tr}>
              <td className={styles.name}>{user.first_name} {user.last_name}</td>
              <td className={styles.email}>{user.email}</td>
              <td className={styles.title}>{emp.employee_title}</td>
              {profile && profile.is_owner && <td className={styles.permissions}>{this._userTypeLabel(emp)}</td>}

              <td className={styles.access}>
                {user.employee_outlets.length > 1 &&
                <OverlayTrigger placement='top' overlay={popover}>
                  <button className='btn btn-info'>{user.employee_outlets.length} Outlets</button>
                </OverlayTrigger>
                }
                {user.employee_outlets.length === 1 && user.employee_outlets[0].outlet.name}
              </td>
              <td className={styles.resend}>
                {!emp.is_confirmed && <button onClick={() => this._resendInvitation(user.email)} className='btn btn-primary'>
                  Resend Invitation
                </button>}
              </td>
              <td className={styles.delete}>
                <button onClick={() => this._askConfirmDelete(emp)} className='btn btn-danger'>
                  <i className='glyphicon glyphicon-trash' />
                </button>
              </td>
            </tr>)
          })}
        </tbody>
      </table>
    </div>)
  }

  _resendInvitation (email) {
    this.props.dispatch(resendInvitation(email))
  }

  _askConfirmDelete (deletedEmployee) {
    this.props.dispatch(askDeleteEmployee(deletedEmployee))
  }

  /**
   * @see https://github.com/mokapos/moka-rails/blob/master/app/assets/javascripts/moka/controllers/employees_controller.js#L310
   * @param emp
   * @return {*}
   * @private
   */
  _userTypeLabel (emp) {
    if (!emp) {
      return null
    }
    let userType = 0
    emp.user.employee_outlets.forEach((eo) => {
      userType = eo.user_type
    })
    return [ 'App only', 'App and Backoffice' ][userType]
  }
}

StaffList.propTypes = {

}

function mapStateToProps (state) {
  return {
    data: {
      employee: {
        list: state.employee.list
      }
    }
  }
}

export default connect(mapStateToProps)(StaffList)



// WEBPACK FOOTER //
// ./app/pages/Employees/List/StaffList/StaffList.js